import React from 'react'
import tripPriceHelper from './../../../helpers/trip-price.helper'
import TripOptionComponent from './trip-option.component'
import { connect } from 'react-redux'
import { dateHelper } from './../../../helpers/date.helper'

function TripOptionContainer({
	price,
	origin,
	arrival,
	busClass,
	onSelect,
	tripDate,
	className,
	departure,
	promotion,
	freeSeats,
	upgradeTo,
	canUpgrade,
	busCompany,
	destination,
	showFreeSeats,
	forReturnTrip,
	promotionPercent,
	conversionParameters,
	raceDate,
	ehConexao,
	conexao,
	noBusChange,
}) {
	const isOnFire = freeSeats < 10
	const daysDiff = dateHelper.getDaysDiff(arrival, departure)
	const showDaysDiff = daysDiff > 0
	const prices = tripPriceHelper.calculatePrices({
		upgradeTo,
		canUpgrade,
		forReturnTrip,
		price: +price.value,
		conversionParameters,
		busCompany,
		promotionPercent,
	})

	return (
		<TripOptionComponent
			origin={origin}
			tripDate={tripDate}
			busClass={busClass}
			daysDiff={daysDiff}
			isOnFire={isOnFire}
			onSelect={onSelect}
			promotion={promotion}
			className={className}
			freeSeats={freeSeats}
			busCompany={busCompany}
			canUpgrade={canUpgrade}
			destination={destination}
			prices={prices}
			showDaysDiff={showDaysDiff}
			showFreeSeats={showFreeSeats}
			promotionPercent={promotionPercent}
			arrival={dateHelper.getHours(arrival)}
			departure={dateHelper.getHours(departure)}
			formattedDiff={dateHelper.getFomarttedDiff(departure, arrival)}
			raceDate={raceDate}
			ehConexao={ehConexao}
			conexao={conexao}
			noBusChange={noBusChange}
		/>
	)
}

const mapStateToProps = ({ tripPrice }) => ({
	conversionParameters: tripPrice.conversionParameters,
})

const TripOption = connect(mapStateToProps)(TripOptionContainer)

export default TripOption
